import { connect } from 'react-redux';

import App from '../../App';

import { showLoader, hideLoader } from '../Loader/slice';

const mapDispatchToProps = (dispatch: any) => {
	return {
		showLoader: () => {
			dispatch(showLoader());
		},
		hideLoader: () => {
			dispatch(hideLoader());
		},
	};
};

export default connect(null, mapDispatchToProps)(App);
